var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Modal } from "react-bootstrap";
import Button from "@irati/ui/src/Button";
import { H2 } from "@irati/ui/src/Headings";
import { isPromise } from "@irati/utils/promise";
import { FormattedMessage } from "@irati/utils/lang";
import Flex from "@irati/ui/src/Flex";
import Loading from "@irati/ui/src/Loading";
import { Hr } from "@irati/ui/src/Layout";
var AreYouSurePopUp = /** @class */ (function (_super) {
    __extends(AreYouSurePopUp, _super);
    function AreYouSurePopUp(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = function () {
            _this.setState({ open: !_this.state.open });
        };
        _this.handleSubmit = function () {
            var submit = _this.props.onSubmit();
            if (isPromise(submit)) {
                submit.then(function () { return _this.toggle(); });
            }
            else {
                _this.toggle();
            }
        };
        _this.handleCancel = function () {
            _this.props.onCancel();
            _this.toggle();
        };
        _this.state = {
            open: props.open
        };
        return _this;
    }
    AreYouSurePopUp.prototype.render = function () {
        var open = this.state.open;
        var _a = this.props, text = _a.text, load = _a.load, buttonText = _a.buttonText, cancelButtonText = _a.cancelButtonText;
        return (React.createElement(React.Fragment, null,
            React.createElement(Modal, { dialogClassName: "areYouSurePopUp", show: open, onHide: this.handleCancel },
                React.createElement(Flex, { direction: "column", padding: 4 },
                    React.createElement(H2, null, text),
                    React.createElement(Hr, null),
                    React.createElement(Flex, { justifyContent: "flex-end", alignItems: "center" },
                        React.createElement(Button, { tertiary: true, onClick: this.handleCancel, marginRight: true, id: "admin_areYouSure_button_cancel" }, cancelButtonText || React.createElement(FormattedMessage, { id: "platform.components.areYouSurePopUp.button.cancel" })),
                        React.createElement(Loading, { load: load, useLoader: false }),
                        React.createElement(Button, { primary: true, load: load, onClick: this.handleSubmit, id: "admin_areYouSure_button_submit" }, buttonText))))));
    };
    AreYouSurePopUp.defaultProps = {
        cancelButtonText: null,
        load: null,
        onCancel: function () { return undefined; },
        open: false
    };
    return AreYouSurePopUp;
}(PureComponent));
export default AreYouSurePopUp;
